import { render, staticRenderFns } from "./BusinessMenu.vue?vue&type=template&id=00bac266&scoped=true&"
import script from "./BusinessMenu.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenu.vue?vue&type=style&index=0&id=00bac266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bac266",
  null
  
)

export default component.exports